import { useRef, useEffect } from 'react';

export function useAudioAnalysis(setAudioLevel) {
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const sourceRef = useRef(null);

  useEffect(() => {
    // Initialize audio context
    if (!audioContextRef.current) {
      audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
    }

    // Initialize analyzer
    if (!analyserRef.current) {
      analyserRef.current = audioContextRef.current.createAnalyser();
      analyserRef.current.fftSize = 2048;
      analyserRef.current.smoothingTimeConstant = 0.8;
    }

    // Set up analysis loop
    const bufferLength = analyserRef.current.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);
    
    const analyzeAudio = () => {
      if (!analyserRef.current) return;

      analyserRef.current.getByteTimeDomainData(dataArray);
      let sum = 0;
      for (let i = 0; i < bufferLength; i++) {
        const amplitude = (dataArray[i] - 128) / 128;
        sum += amplitude * amplitude;
      }
      const rms = Math.sqrt(sum / bufferLength);
      
      // Scale RMS to a more useful range (0 to 1)
      const scaledRMS = Math.min(rms * 5, 1);
      setAudioLevel(scaledRMS);
    };

    const intervalId = setInterval(analyzeAudio, 50);

    return () => {
      clearInterval(intervalId);
      if (sourceRef.current) {
        sourceRef.current.disconnect();
      }
    };
  }, [setAudioLevel]);

  return {
    audioContextRef,
    analyserRef,
    sourceRef
  };
} 